import React from "react";

export interface LabelProps {
  x?: number;
  y?: number;
  text?: string;
  fontSize?: number;
  color?: string;
}

export const Label: React.FC<LabelProps> = ({
  x = 100,
  y = 100,
  text = "",
  fontSize = 14,
  color = "#1f2937",
}) => (
  <text x={x} y={y} fill={color} fontSize={fontSize} fontFamily="system-ui, sans-serif">
    {text}
  </text>
);
